import type { TrayModel } from '../tray/TrayModel';

export class BoosterRedrawModel {
  constructor(private readonly trayModel: TrayModel) {}

  public execute(): void {
    this.trayModel.refillItems(false);
  }
}
